import React from "react";
import LoginForm from "./LoginForm";
import {
  LoginLayout,
  StyledRow,
  StyledLeftCol,
  StyledRightCol,
  StyledImage,
  StyledLogo,
} from "./style";
import LoginBackground from "../../assets/images/LoginBackground.png";
import Logo from "../../assets/icons/LasuLoginLogo.svg";

const Login = () => {
  return (
    <LoginLayout>
      <StyledRow>
        <StyledLeftCol span={12}>
          <StyledImage src={LoginBackground} />
          <StyledLogo src={Logo} />
        </StyledLeftCol>
        <StyledRightCol span={12}>
          <LoginForm />
        </StyledRightCol>
      </StyledRow>
    </LoginLayout>
  );
};

export default Login;
